import 'slick-carousel';
import 'sass-to-js/js/dist/sass-to-js.min.js';
import ReadMoreCollapse from 'modules/readMoreCollapse';

export default (function() {
	let _$carousel = null;
	let _breakpoints;

	function init($carousel, nav) {
		_$carousel = $carousel;
		_breakpoints = $('.js-breakpoint-sniffer').sassToJs({pseudoEl: '::after', cssProperty: 'content'});

		if ($carousel.length > 0) {
			$carousel.each(initCarousel);
		}

		onResize();
		$(window).on('resize', () => {
			onResize();
		});
	}

	function initCarousel(index,carousel) {
		const _$nav = $(carousel).parent().siblings('.js-review-nav');
		const collapse = $(carousel).find('.js-collapse');

		$(carousel).slick({
			cssEase       : 'cubic-bezier(0.15, 0, 0, 1)',
			infinite      : false,
			speed         : 500,
			fade          : false,
			dots          : false,
			adaptiveHeight: true,
			slidesToShow  : 2,
			slidesToScroll: 1,
			variableWidth : false,
			appendArrows: _$nav,
			prevArrow   : '<a class="slick-prev slick-arrow" href="#"><i class="icon icon-chevron-left" aria-hidden="true"></i></a>',
			nextArrow   : '<a class="slick-next slick-arrow" href="#"><i class="icon icon-chevron-right" aria-hidden="true"></i></a>',
			responsive    : [{
				breakpoint: parseInt(_breakpoints.xxl, 10),
				settings  : {
					slidesToShow  : 1,
				}
			}]
		});
		$(collapse).unbind('collapse:toggle');
		$(collapse).on('collapse:toggle', () => {
			$(carousel).slick('setDimensions');
			$(carousel).slick('setPosition');
		});
	}

	// slick slider resize is broken, and can only work with pixel dimensions on its container
	function onResize() {
		if (!_$carousel) {
			return;
		}

		ReadMoreCollapse.init();

		_$carousel.each(function(){
			$(this).css({
				'width' : '',
				'height': ''
			});

			const collapse = $(_$carousel).find('.js-collapse');
			$(collapse).unbind('collapse:toggle');
			$(collapse).on('collapse:toggle', () => {
				$(_$carousel).slick('setDimensions');
				$(_$carousel).slick('setPosition');
			});
		});

		_$carousel.each(function() {
			$(this).css({
				'width' : $(this).parent().width()
			});
		});
	}

	return {
		init,
	};
})();